"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const getPostMedia_1 = require("../hocs/getPostMedia");
const components_1 = require("modules/shared/components");
const PostMedia = ({ media, width, height }) => (React.createElement("div", { className: 'width100' },
    React.createElement(components_1.TextWithHighlightedElements, { className: 'margin-bottom-1x', text: media.text }),
    React.createElement(components_1.MediaCarousel, { images: media.images, videos: media.videos, videosUrls: media.videoUrls, width: width, height: height })));
exports.default = getPostMedia_1.default(PostMedia);
